import { listeAccordeonMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [listeAccordeonMock('priceExplanation')];

export const pedagogiePrixMock: SlugPage = {
  ...pageBase({
    title: 'Pedagogie Prix',
    type: 'undefined',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
